<template>
    <Breadcrumbs
        main="Liste des villes"
        mains="Liste des villes"
        :title="$t('mobileAppVersionList.title')"
    />
    <div class="container-fluid">
        <div class="row">
            <MobileVersionList :town-id="townId" :town-name="townName" />
        </div>
    </div>
</template>

<script lang="ts" setup>
import { ref, defineAsyncComponent, onMounted, computed } from 'vue';
import { useRoute } from 'vue-router';
import ApiServices from '@/services/apiServices';

const MobileVersionList = defineAsyncComponent(
    () => import('@/components/theme/town/MobileVersionList.vue'),
);

const route = useRoute();
const townId = computed(() => route.query.townId as string);
const townName = ref('');

onMounted(async () => {
    if (townId.value) {
        ApiServices.get('town', { id: townId.value }).then((response: any) => {
            townName.value = response?.name ?? '';
        });
    }
});
</script>
